import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { Router } from '@angular/router';

import { NotificationService } from '../../shared/services/notification.service';
import { PremiitError } from '../../utils/premiit-error';
import { User } from '../../pages/users/user';
import { UserService } from '../../pages/users/user.service';
import * as userActions from '../actions/users.actions';
import { ResponseData } from 'src/app/utils/response';

@Injectable()
export class UserEffects {
  constructor(private actions$: Actions, private userService: UserService, private notify: NotificationService, private router: Router) {}

  public getUsersEffect = createEffect(
    () => this.actions$.pipe(
      ofType(userActions.getUsersAction),
      mergeMap(() => {
        return this.userService.getUsers()
          .pipe(
            map((response: ResponseData<User[]>) => {
              const users: User[] = response.data;
              return userActions.getUserSucessAction({ users });
            }),
            catchError((error: PremiitError) => {
              return of(userActions.getUserErrorAction({ error }));
            })
          );
      })
    )
  );

  public createUserEffect = createEffect(
    () => this.actions$.pipe(
      ofType(userActions.createUserAction),
      mergeMap((action) => {
        return this.userService.createUser(action.user)
          .pipe(
            map( () => {
              this.notify.success('usuario creado con exito');
              this.router.navigate(['users']);
              return userActions.createUserSucessAction();
            }),
            catchError( error => {
              this.notify.customError(error);
              return of(userActions.createUserErrorAction({ error }));
            })
          );
      })
    )
  );

  public deleteUserEffect = createEffect(
    () => this.actions$.pipe(
      ofType(userActions.deleteUserAction),
      mergeMap((action) => {
        return this.userService.deleteUser(action.user)
          .pipe(
            map((response: ResponseData<User>) => {
              this.notify.success('Usuario eliminado');
              let user: User = response.data;
              return userActions.deleteUserSucessAction({ user });
            }),
            catchError( (error: PremiitError) => {
              this.notify.customError(error);
              return of(userActions.deleteUserErrorAction({ error }));
            })
          );
      })
    )
  );

  public updateUserEffect = createEffect(
    () => this.actions$.pipe(
      ofType(userActions.updateUserAction),
      mergeMap((action) => {
        return this.userService.updateUser(action.user)
          .pipe(
            map((response: ResponseData<User>) => {
              let user: User = response.data;
              this.notify.success('Usuario actualizado con éxito');
              this.router.navigate(['users']);
              return userActions.updateUserSucessAction({ user });
            }),
            catchError( (error: PremiitError) => {
              this.notify.customError(error);
              return of(userActions.updateUserErrorAction({ error }));
            })
          );
      })
    )
  );
}
